import bootstrap from "bootstrap";
import jquery from "jquery";
import popper from "popper.js";
import AOS from "./components/AnimationAOS";
import * as AnimateNavbar from "./components/AnimateNavbar";

import Search from "./components/Search";
import DeclaratiiAvere from "./components/DeclaratiiAvere";
import Sesizari from "./components/Sesizari";
import Opinii from "./components/Opinii";

import dropdown from "./components/Bdropdown";

dropdown();

if (document.querySelector(".auto-dismiss")) {
  setTimeout(() => {
    document.querySelector(".auto-dismiss").remove();
  }, 5000);
}
